<template>
  <div class="about">
    <h1>A site for events</h1>
    <h4> Events for Good </h4>
  </div>
</template>
